import styled from 'styled-components';

import ButtonLink from '../../interface/ButtonLink';
import Container from '../../interface/Container';

export const CtaSubtitle = styled.span`
  font-size: var(--font-size-md);
  display: block;

  @media (${({ theme }) => theme.respondTo.mobile}) {
    margin-top: 3rem;
  }

  @media (${({ theme }) => theme.respondTo.tablet}) {
    margin-left: 4.5rem;
  }
`;

export const CtaWrapper = styled.div`
  margin-top: 3rem;

  @media (${({ theme }) => theme.respondTo.tablet}) {
    display: flex;
    align-items: center;
    margin-top: 9rem;
  }
`;

export const ImageOverlay = styled.div`
  width: 100%;
  height: 100%;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0.3) 0%, rgba(0, 0, 0, 0.3) 100%);
  position: absolute;
  top: 0;
  left: 0;
`;

export const ImageWrapper = styled.div`
  width: 100%;
  height: 60.5rem;
  position: absolute;

  @media (${({ theme }) => theme.respondTo.tablet}) {
    height: 84rem;
  }

  > * {
    width: 100%;
    height: 100%;
    border-bottom-right-radius: 10rem;

    @media (${({ theme }) => theme.respondTo.tablet}) {
      border-bottom-right-radius: 30rem;
    }
  }
`;

export const StyledButtonLink = styled(ButtonLink)`
  @media (${({ theme }) => theme.respondTo.mobile}) {
    width: 100%;
    text-align: center;
  }
`;

export const StyledContainer = styled(Container)`
  position: relative;
  padding-bottom: 7.5rem;

  @media (${({ theme }) => theme.respondTo.tablet}) {
    padding-bottom: 12rem;
  }
`;

export const Title = styled.h1`
  font-size: 5.2rem;

  @media (${({ theme }) => theme.respondTo.tablet}) {
    font-size: 8rem;
    max-width: 70rem;
  }
`;

export const Wrapper = styled.div`
  display: flex;
  align-items: flex-end;
  height: 60.5rem;
  margin-bottom: 8rem;
  color: var(--color-text-light);

  @media (${({ theme }) => theme.respondTo.tablet}) {
    height: 84rem;
  }

  @media (${({ theme }) => theme.respondTo.desktop}) {
    margin-bottom: 14.5rem;
  }
`;
